import React from "react";
import { Form, Row, Col } from "antd";
import {
  StyledInput,
  StyledFormItem,
  MainHeading,
  StyledCountry,
  StyledRegion,
} from "./styles";

const AddressForm = ({ value, onChange }) => {
  const [form] = Form.useForm();
  const country = Form.useWatch("country", form);

  const emitValues = (_, allValues) => {
    // Do not trim here — trimming on every keystroke + parent re-sync
    // strips trailing spaces and makes the spacebar appear broken.
    onChange?.({
      firstName: allValues.firstName ?? "",
      lastName: allValues.lastName ?? "",
      phoneNumber: allValues.phoneNumber ?? "",
      streetAddress: allValues.streetAddress ?? "",
      apartmentNumber: allValues.apartmentNumber ?? "",
      city: allValues.city ?? "",
      state: allValues.state || "",
      country: allValues.country || "",
      zip: allValues.zip ?? "",
    });
  };

  return (
    <Form
      form={form}
      name="addressForm"
      layout="vertical"
      onValuesChange={emitValues}
      initialValues={value || undefined}
    >
      <StyledFormItem>
        <MainHeading>{`Ship to (this order only)`}</MainHeading>
      </StyledFormItem>
      <Row gutter={16}>
        <Col span={12}>
          <StyledFormItem
            name="firstName"
            label="First Name"
            rules={[{ required: true, message: "Please input first name!" }]}
          >
            <StyledInput />
          </StyledFormItem>
        </Col>
        <Col span={12}>
          <StyledFormItem
            name="lastName"
            label="Last Name"
            rules={[{ required: true, message: "Please input last name!" }]}
          >
            <StyledInput />
          </StyledFormItem>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <StyledFormItem name="phoneNumber" label="Phone Number">
            <StyledInput />
          </StyledFormItem>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <StyledFormItem
            name="streetAddress"
            label="Street Address"
            rules={[
              { required: true, message: "Please input your street address!" },
            ]}
          >
            <StyledInput />
          </StyledFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <StyledFormItem name="apartmentNumber" label="Apartment Number">
            <StyledInput />
          </StyledFormItem>
        </Col>
        <Col span={12}>
          <StyledFormItem
            name="country"
            label="Country"
            rules={[{ required: true, message: "Please select your country!" }]}
          >
            <StyledCountry defaultOptionLabel="Select Country" />
          </StyledFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <StyledFormItem
            name="state"
            label="State"
            rules={[{ required: true, message: "Please select your state!" }]}
          >
            <StyledRegion
              country={country}
              defaultOptionLabel="Select State"
              blankOptionLabel="Select State"
            />
          </StyledFormItem>
        </Col>
        <Col span={8}>
          <StyledFormItem
            name="city"
            label="City"
            rules={[{ required: true, message: "Please input your city!" }]}
          >
            <StyledInput placeholder="City" />
          </StyledFormItem>
        </Col>
        <Col span={8}>
          <StyledFormItem
            name="zip"
            label="Zip"
            rules={[{ required: true, message: "Please input your zip!" }]}
          >
            <StyledInput />
          </StyledFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default AddressForm;
